<script setup lang="ts">
import { onMounted, ref } from 'vue';

const isVisible = ref<boolean>(false);

onMounted(() => {
  isVisible.value = true;
});
</script>

<template>
  <transition name="slide-up">
    <slot v-if="isVisible" />
  </transition>
</template>

<style scoped lang="scss">
.slide-up-enter-active {
  transition: transform var(--transition-medium);
}

.slide-up-enter-from {
  transform: translateY(100%);
}

.slide-up-enter-to {
  transform: translateY(0);
}
</style>
